import VideoGallery from '../../../js/src/__page/videoGallery';

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		VideoGallery.init();
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
